import { DeadlineKind, DeadlineSubject, type UpcomingDeadlineDto } from "../../autogen/bff-api";
import { urls } from "../../urls";

export const deadlineTarget = (deadline: UpcomingDeadlineDto): string => {
  switch (deadline.subject) {
    case DeadlineSubject.SourcingEventV2:
      return urls.app.sourcingEvents.view.go(deadline.subjectId);
    case DeadlineSubject.Contract:
      return urls.app.contracts.view.go(deadline.subjectId);
    case DeadlineSubject.ContractTask:
      return deadline.parentId
        ? urls.app.contracts.view.task(deadline.parentId, deadline.subjectId)
        : urls.app.contracts.tasks;
  }
};

// The only kinds whose hour someone chose. A contract row's dueAt is the end of its due date
// (UpcomingDeadlineRepositoryJdbi) and a standstill expiry the end of its last day
// (StandstillRules.expiryFor), so 23:59 there is arithmetic and says nothing.
export const TIMED_DEADLINE_KINDS: ReadonlySet<DeadlineKind> = new Set([
  DeadlineKind.BidSubmission,
  DeadlineKind.QuestionDeadline,
  DeadlineKind.RequestToParticipate,
  DeadlineKind.NegotiationRound,
]);
